/* eslint-disable no-unused-vars */
/* global G */
import find from 'lib/sequence/component/children/find'
import { asyncPipeSpread, setKey } from 'lib/util'
import { reset } from 'lib/sequence/component/state/value'
import updateComponent from 'app/_shared/action/partial/favorite/updateComponent'

/**
 * Resets `component` recursively.
 *
 * @param {Gaia.Component.Spec} component   the current action's main component
 */
const bulkReset = (component) => {
  reset(component)
  component[G.CHILDREN]?.length && component[G.CHILDREN].forEach((child) => { bulkReset(child) })
}

/**
 * Resets favorite specific fields.
 *
 * @param {Gaia.AppModule.Spec} module the current module composition object
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const resetFields = module => async (components, ...args) => {
  const { favoriteModal } = components

  favoriteModal && bulkReset(favoriteModal)
  favoriteModal && setKey(false, 'open', favoriteModal[G.STATE])

  return [components, ...args]
}

/**
 * Favorite Success Action
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  resetFields(module),
  updateComponent('file')(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
